import { QueryClient } from '@tanstack/react-query';

const IS_DEV = import.meta.env.DEV;

export const queryClient = new QueryClient( {
    defaultOptions: {
        queries: {
            retry: IS_DEV ? 0 : 1,
            staleTime: IS_DEV ? 60 * 1000 : 0,
            refetchOnMount: !IS_DEV,
            refetchOnWindowFocus: false,
            refetchOnReconnect: !IS_DEV,
        },
    },
});
